var React = require('react');

function HeadshotBorderInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("g",{"id":"Hi-fi-/-Desktop-v3","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"About-/-Bio","transform":"translate(-58.000000, -184.000000)","fill":"#00ADE6"},React.createElement("path",{"d":"M522,184 L522,646 L58,646 L58,184 L522,184 Z M457,249 L124,249 L124,581 L457,581 L457,249 Z","id":"Combined-Shape"})))]);
}

HeadshotBorderInline.defaultProps = {"width":"464px","height":"462px","viewBox":"0 0 464 462","version":"1.1"};

module.exports = HeadshotBorderInline;

HeadshotBorderInline.default = HeadshotBorderInline;
